// extracted by mini-css-extract-plugin
export default {"text":"CatList_text__Yy6Qv"};